export default __webpack_public_path__ + "static/media/filtrar-icon.5a24c898.svg";